import "@aws-amplify/ui-react/styles.css";
import {
 //withAuthenticator,
  View,
  Divider,
  Link,
  Authenticator
} from "@aws-amplify/ui-react";
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './views/navbar';
import styled from "styled-components";
import { GlobalContext } from "./context/global";
import { useState } from "react";
import { IEventData, IUserData } from "./interfaces";
import { Navigate } from "react-router-dom";
import { loginComponents } from "./components/loginComponents";
import { ThemeProvider, Theme } from '@aws-amplify/ui-react';
import { theme } from "./theme";
import { ScrollToTop } from "./components/scrollToTop";


const NiceDivider = styled(Divider)`
margin-bottom:1rem;
martin-top:1rem;
`

const AppView = styled(View)`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
  height: 100vh
`


// We have no full width pages currently, so we'll set this to line up on the LGH at max a few hundred px for now.
// "margin: auto" centers this, remove it to left align.
// overflow hidden is for the calorie page where some margin seems to flow out the RHS of page and cause an issue at low screen widths.
const Page = styled(View)`
  display:flex;
  flex-direction:row;
  flex:1;
  width:100%;
  max-width:600px;
  margin:auto;
`

const Footer = styled(View)`
  height 100rem;
  background-color: rgba(239, 239, 240, 255);
  padding:1rem;
`

function App({ signOut } : any) {

  const curLocation = useLocation();

  const [nutritionData, setNutritionData] = useState({
    depletion: {
      calories: 0,
      saltMg: 0,
      waterMl : 0
    },
    products: {
    },
    hasLoaded: false,
  });
  const [ basket, setBasket] = useState({
    gels: 0,
    drinks: 0,
    bars: 0,
    saltChew: 0,
    saltCapsule: 0,
  })
  const [userData, setUserData] = useState<{ user? : IUserData, haveFetched: boolean}>({ haveFetched : false});

  const addGel = (x : number) => {
    setBasket((old) => {return {...old, gels: Math.max(old.gels + x, 0)}})
  }
  const addDrink = (x : number) => {
    setBasket((old) => {return {...old, drinks: Math.max(old.drinks + x,0)}})
  }
  const addBar = (x : number) => {
    setBasket((old) => {return {...old, bars: Math.max(old.bars + x, 0)}})
  }
  const addSaltChew = (x : number) => {
    setBasket((old) => {return {...old, saltChew: Math.max(old.saltChew + x, 0)}})
  }
  const addSaltCapsule = (x : number) => {
    setBasket((old) => {return {...old, saltCapsule: Math.max(old.saltCapsule + x, 0)}})
  }

  const [eventDataState, setEventDataState] = useState<{event?: Partial<IEventData>}>({ })
  /*
  
  We now add a little bit of additional logic
  - Get user as soon as the app is fired up.
  - If no user, try again a few times.
  - if we just see an ID and email and nothing else, it's first login, redirect to /userData to get the data.
  - if we see a 'full' user, we render welcome.
  */


  if (curLocation.pathname != "/user-initial" && (!userData || !userData.user?.ID)) {
    // an exception to us wanting to load user data is us landing back from checkout.
    // we'll deal with this later (since we actually need the user id, lets just do nothing for now)
    if (curLocation.pathname = "/event/complete") {
      // do nothing
    } else {  
      return <Navigate to="/user-initial" replace/>
    }
  }

  const signOutButton = <Link onClick={signOut}>Sign Out</Link>//<Button variation="link" size="small" onClick={signOut}>Sign Out</Button>;


  return (
    <GlobalContext.Provider value={{
      nutritionData : nutritionData,
      setNutritionData : setNutritionData,
      userData: userData,
      setUserData: (newData) => setUserData((oldUserData) => {
        //if we have a user already, and are setting a new one,
        if (oldUserData.user && newData.user) {
          return {
            haveFetched: newData.haveFetched,
            user: {...oldUserData.user, ...newData.user}
          }
        }
        // otherwise just return new
        return newData;
      }),
      clearBasket: () => {setBasket({ gels: 0, drinks: 0, bars: 0, saltChew: 0, saltCapsule: 0})},
      basket,
      addGel,
      addDrink,
      addBar,
      addSaltChew,
      addSaltCapsule,

      eventData: eventDataState,
      setEventData: (data:Partial<IEventData>) => {
        setEventDataState({ event: data})
      },
      clearEventData: () => {
        setEventDataState({});
      }
    }}>
    <ThemeProvider theme={theme}>
     <Authenticator components={loginComponents}>
      {
      ({ signOut, user }) => {
        const signOutButton = <Link onClick={signOut}>Sign Out</Link>
        return (
         
        <AppView className="App">
        <Navbar signOutButton={signOutButton} />
        <ScrollToTop />
        <Page>
          <Outlet />
        </Page>
        {/*<Footer>
          <Button onClick={signOut}>Sign Out</Button>
    </Footer>*/}
      </AppView>)
      }
    }
    </Authenticator>
    </ThemeProvider>

    
    </GlobalContext.Provider>
  );
}

export default App;